<template>
  <div
    id="page"
    v-if="page === currentPage || page === currentPage - 1 || page === currentPage + 1"
    :class="classObject"
    >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Page',
  props: ['currentPage', 'page'],
  computed: {
    classObject() {
      let pageClass;
      switch(this.currentPage) {
        case this.page - 1: 
          pageClass = 'page-after';
          break;
        case this.page:
          pageClass = 'page-active';
          break;
        case this.page + 1:
          pageClass = 'page-before'
          break;
        default:
          break;
      }

      return pageClass
    }
  }
}
</script>
<style scoped>
  #page {
    transition: transform 1.2s cubic-bezier(0.19, 1, 0.22, 1), opacity 0.7s ease-in-out;
    width: 100%;
  }

  .page-before,
  .page-after {
    position: absolute;
  }

  .page-before {
    top: 0;
    left: 0;
    transform: translateX(-110%);
    opacity: 0;
  }
  .page-active {
    top: 0;
    transform: translateX(0);
    opacity: 1;
  }

  .page-after {
    top: 0;
    right: 0;
    transform: translateX(110%);
    opacity: 0;
  }

</style>